import * as React from 'react'
import { isComponentBlock } from '@basehub/data/replicache/index'
import { Blocks } from '..'
import { TreeManager } from '@basehub/utils/tree/index'
import type {
  Block,
  CommonBlocksCompoundIndexes,
  InstanceBlock,
} from '@basehub/data/replicache/index'

export const InstanceBlockInput = ({
  block,
  path,
  blockTreeManager,
}: {
  block: InstanceBlock
  path: string
  blockTreeManager: TreeManager<Block, CommonBlocksCompoundIndexes>
}) => {
  const targetBlock = React.useMemo(() => {
    if (!blockTreeManager) return null
    const targetNode = blockTreeManager.getNode(
      block.typeOptions.targetBlockId,
      { fallbackKey: 'sourceBlockId' }
    )
    if (!targetNode) return null
    if (!isComponentBlock(targetNode.value)) {
      throw new Error('instance block target only supports component blocks')
    }
    return targetNode.value
  }, [block.typeOptions.targetBlockId, blockTreeManager])

  if (!targetBlock) return null
  return <Blocks block={block} path={path} />
}
